import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { ProductMedia } from '@asm/features/sync/services/sync/sync.interfaces';

export interface LocalMix {
  code: string;
  description: string;
  banner?: ProductMedia | null;
}

@Injectable({ providedIn: 'root' })
export class MixRepository extends RepositoryBase<LocalMix> {
  protected readonly KEY_PATH = 'mixes';
}
